import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-[calc(100vh-160px)] flex flex-col items-center justify-center text-center px-6 py-12 bg-light">
      {/* Adjust min-height based on Navbar + Footer height if needed */}
      <SEO 
        title="Page Non Trouvée"
        description="La page que vous cherchez n'existe pas."
      />
      
      <h1 className="text-6xl font-bold text-primary font-heading mb-4">
        404
      </h1>
      <h2 className="text-2xl font-semibold text-dark font-heading mb-6">
        Oups! Page Non Trouvée
      </h2>
      <p className="text-lg text-darkGray font-body mb-8 max-w-md">
        Il semble que la page que vous essayez d'atteindre n'existe pas ou a été déplacée.
      </p>
      <Link 
        to="/" 
        className="inline-block bg-primary text-white py-3 px-7 rounded-full font-bold font-body transition duration-300 ease-in-out shadow-md cursor-pointer hover:bg-primary/90 no-underline"
      >
        Retour à l'Accueil
      </Link>
    </div>
  );
};

export default NotFoundPage; 